import { render, staticRenderFns } from "./EmployeeReports.vue?vue&type=template&id=36b47e3d&"
import script from "./EmployeeReports.vue?vue&type=script&lang=js&"
export * from "./EmployeeReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports